import type { FC, PropsWithChildren } from 'react'

import type { Category } from '../../Catalog'

import List, { ListItem } from '../List'

interface DesktopCategoriesListProps extends PropsWithChildren {
  categoryId: string | null
  categories: Category[]
  onCategoryChange: (value: string | number | null) => void
}

const DesktopCategoriesList: FC<DesktopCategoriesListProps> = ({ categoryId, categories, onCategoryChange }) => {
  return (
    <List value={categoryId ?? `all`} onChange={onCategoryChange}>
      <ListItem value="all" href={`/catalog`}>
        All
      </ListItem>
      {categories.map(({ slug, name }) => (
        <ListItem key={slug} value={slug} href={`/catalog/${slug}`}>
          {name}
        </ListItem>
      ))}
    </List>
  )
}

export default DesktopCategoriesList
